import { __extends } from "tslib";
import { SdkMessageTypes } from '../constants';
import { CallModalities } from '../interfaces';
import { validLegacyLinkOrigin } from '../utils/helpers';
import { BaseMessageHandler } from './base-message-handler';
import { callServiceAndFormulateAppMessageResult, onSdkError } from './messageHandlingUtils';
var CallMessageHandler = /** @class */ (function (_super) {
    __extends(CallMessageHandler, _super);
    function CallMessageHandler(appSdkHost, callService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.callService = callService;
        return _this;
    }
    CallMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.call.startCall, function (_, startCallParams) {
            return callServiceAndFormulateAppMessageResult(_this.callService.startCall, startCallParams);
        }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.call.startCall, error, scenario); },
        });
    };
    CallMessageHandler.prototype.validateDependencies = function () {
        if (!this.callService) {
            throw 'No callService provided';
        }
    };
    return CallMessageHandler;
}(BaseMessageHandler));
export { CallMessageHandler };
var CallLegacyLinkHandler = /** @class */ (function () {
    function CallLegacyLinkHandler(callService) {
        this.callService = callService;
    }
    CallLegacyLinkHandler.prototype.tryGetDataFromLink = function (url) {
        var _a;
        if (!this.callService) {
            return null;
        }
        if (url.origin != validLegacyLinkOrigin || url.pathname != '/l/call/0/0') {
            return null;
        }
        var users = (_a = url.searchParams.get('users')) === null || _a === void 0 ? void 0 : _a.split(',');
        var withVideo = url.searchParams.get('withVideo') == 'true' ? true : false;
        var source = url.searchParams.get('source') || undefined;
        if (!users) {
            return null;
        }
        return {
            targets: users,
            requestedModalities: withVideo ? [CallModalities.Audio, CallModalities.Video] : [CallModalities.Audio],
            source: source,
        };
    };
    CallLegacyLinkHandler.prototype.executeData = function (params) {
        return this.callService.startCall(params).then(function () { });
    };
    return CallLegacyLinkHandler;
}());
export { CallLegacyLinkHandler };
//# sourceMappingURL=call-message-handler.js.map